/* cSpell:disable */
import React from 'react';

import { SafeHtml } from '@bcp-channels-sharedcomponents-reactjs/core';
import { Tooltip, TooltipRef } from '@bcp-nextgen-dx-component-factory/design-system';
import { useGetCurrentBreakpoint } from '@hooks';

import { TooltipInnerProps } from './tooltip';

/**
 *
 *
 * @return {*}  {JSX.Element}
 */
export const TooltipBcp: React.FC<TooltipInnerProps> = (props: TooltipInnerProps): JSX.Element => {
	const { title, content, onOpenFallback } = props;
	const { currentView } = useGetCurrentBreakpoint();
	const tooltipRef = React.useRef<TooltipRef>(null);
	return (
		<div
			onMouseOver={() => {
				tooltipRef.current?.show();
				onOpenFallback?.();
			}}
			onMouseLeave={() => {
				tooltipRef.current?.hide();
			}}
			onClick={() => {
				if (currentView !== 'bigView') {
					onOpenFallback?.();
				}
			}}
		>
			<Tooltip
				key={title}
				inset="s5"
				containerStyles={{ maxWidth: '339px' }}
				triggerMode={currentView === 'bigView' ? 'hover' : 'press'}
				content={
					<Tooltip.Container>
						{title && <Tooltip.Title>{title}</Tooltip.Title>}
						{content && (
							<Tooltip.Description fontSize="size70">{<SafeHtml html={content} />}</Tooltip.Description>
						)}
					</Tooltip.Container>
				}
			>
				<Tooltip.Trigger key={title} size="xxxSmall" />
			</Tooltip>
		</div>
	);
};
/* cSpell:enable */
